import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from "rxjs/Subscription";

import { PVService } from "../../../services/nonanon/pv.service";

import { VehicleService } from "../../../services/nonanon/vehicle/vehicle.service";
import { VehicleInfoService } from "../../../services/nonanon/vehicle/vehicle-info.service";
import { NotificationComponent } from "../../shared/notification.component";
import { AuthService } from "../../../services/auth/auth.service";

@Component({
    selector: 'app-vehicle-owners',
    templateUrl: './vehicle-owners.component.html'
})
export class VehicleOwnersComponent implements OnInit, OnDestroy {
    @ViewChild('notification') notificationComponent: NotificationComponent;

    onVehicleInfoChanged: Subscription;
    onVehicleSelected: Subscription;

  constructor(private pvService: PVService,
              private vehicleService: VehicleService,
              private vehicleInfoService: VehicleInfoService,
              private authService: AuthService) { }

    infoReport: string = "";
    loading: boolean = false;
    hasResults: boolean = false;

    private errorMessage: string = null;
    hasErrors() {
        return this.errorMessage != null;
    }
    getErrorMessage() {
        return this.hasErrors() ? this.errorMessage : "";
    }
    
    private vehicleOwners: Array<any>;

    canCopyToClipboard: boolean = false;

    ngOnInit() {
        this.canCopyToClipboard = this.authService.getUser().canCopyToClipboard;

        this.selectedClientId = 0;
        this.vehicleInfoService.clearVehicleInfo(this.vehicleService.getVehicle().id);


        this.vehicleOwners = this.vehicleInfoService.getVehicleOwners();
        this.hasResults = this.checkIfHasResults();
        this.infoReport = this.vehicleInfoService.getInfoReport();


        this.onVehicleInfoChanged = this.vehicleInfoService.vehicleInfoChanged
            .subscribe(
            () => {
                this.notificationComponent.animateIfError(this.vehicleInfoService.getResponseInfoForOwners());

                if (this.vehicleInfoService.hasErrors()) {
                    this.errorMessage = this.vehicleInfoService.getErrorMessage();
                    this.notificationComponent.animateErrorAction(this.errorMessage);
                } else {
                  this.errorMessage = null;
                  this.vehicleOwners = this.vehicleInfoService.getVehicleOwners();
                  this.hasResults = this.checkIfHasResults();
                  this.notificationComponent.clear();
                }
                this.loading = false;

                this.pvService.clearSelectedClient();
            });
    }

    selectedClientId: number = 0;
    onPersonView(clientId: number, clientTypeId: number) {
        this.selectedClientId = clientId;
        if (clientTypeId == 1) {
            //go to person only if INDIVIDUAL
            this.pvService.setSelectedClient(clientId, 'VehicleOwners');
        }
    }

  ngOnDestroy() {
        //this.onVehicleSelected.unsubscribe();
        this.onVehicleInfoChanged.unsubscribe();
    }

    private checkIfHasResults() {
        if (this.vehicleOwners == null) {
            return false;
        } else {
            return this.vehicleOwners != null && this.vehicleOwners.length > 0;
        }
    }

    copyToClipboard(text) {
        if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy"); // Security exception may be thrown by some browsers.
            } catch (ex) {
                console.warn("Copy to clipboard failed.", ex);
                return false;
            } finally {
                document.body.removeChild(textarea);
            }
        }
    }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/nonanon/vehicle/vehicle-owners.component.ts